export enum Category {
  servicios = 'MCSRV01',
  entretenimiento = 'MCENT01',
  restaurantes = 'MCREST01',
  viajes = 'MCVAJ01',
  otros = 'MCOTR01',
  educacion = 'MCEDUC01',
  cuidadoPersonal = 'MCSBS01',
  tiendas = 'MCTND01',
  impuestos = 'MCIMP01',
  transferencia = 'MCTRF01',
  salud = 'MCSLB01',
  combustible = 'MCCMB01',
}

export enum CategoryName {
  MCSRV01 = 'Servicios',
  MCENT01 = 'Entretenimiento',
  MCREST01 = 'Restaurantes',
  MCVAJ01 = 'Viajes',
  MCOTR01 = 'Otros',
  MCEDUC01 = 'Educación',
  MCSBS01 = 'Cuidado Personal',
  MCTND01 = 'Tiendas',
  MCIMP01 = 'Impuestos',
  MCTRF01 = 'Transferencia',
  MCSLB01 = 'Salud',
  MCCMB01 = 'Combustible',
  DEP = 'Depósito',
  OTH = 'Otros',
  RTR = 'Retiro',
  PG = 'Pago',
  TRF = 'Transferencias',
  Otros = 'Otros',
  OTROS = 'Otros',
  CPV = 'Compra TDD Punto Venta'
}

export enum CreditDebitIndicator {
  DBIT = 'DBIT',
  CRDT = 'CRDT',
}
